angular.module('app').directive('focusMe', ['$timeout', '$parse', function ($timeout, $parse) {
    return {
        //scope: true,   // optionally create a child scope
        restrict: "A",
        link: function (scope, element, attrs) {
            $timeout(function () {
                element[0].focus();
            })

        }
    };
}]);